import React, { useCallback, useLayoutEffect, useState } from 'react';
import Button from 'design-system/Button';
import EmptyComponent from 'design-system/EmptyComponent';
import useColors from 'hooks/useColors';
import { AppView, SettingsItemWithCheckBox, SettingsSection, StatusBar, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { useSetupStepLabel } from 'features/onboarding-report/hooks/useSetupStepLabel';
import { isWeb } from '../../../constants';
const LastFridaySelectionScreen = ({ navigation, route, }) => {
    const { period, onSavePeriod, flow } = route.params;
    const [adjust, setAdjust] = useState(false);
    const colors = useColors();
    const setupStepLabel = useSetupStepLabel(2);
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Select the date',
            headerTitle: EmptyComponent,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const savePeriod = useCallback(() => {
        const resultPeriod = {
            ...period,
            weekNumber: adjust ? undefined : period.weekNumber,
            days: adjust ? [-2, -3, -4, -5, -6, -7, -8] : undefined,
        };
        onSavePeriod(resultPeriod);
    }, [onSavePeriod, period, adjust]);
    return (<AppView avoidHeader isInTab={isWeb}>
      <StatusBar barStyle="dark-content" animated/>
      <ScreenInfoHeader preTitle={flow === 'Onboarding' ? setupStepLabel : undefined} title="Adjust for last day of the month" subTitle="If the date falls on the last day of the month, do you want to reset your period on the previous Friday?"/>
      <SettingsSection noMarginTop>
        <SettingsItemWithCheckBox title="No" selected={!adjust} onPress={() => setAdjust(false)}/>
        <SettingsItemWithCheckBox title="Yes" selected={adjust} onPress={() => setAdjust(true)}/>
      </SettingsSection>
      <Button brand floating title="Continue" onPress={savePeriod}/>
    </AppView>);
};
export default LastFridaySelectionScreen;
